module.exports = __webpack_public_path__ + "static/create-a-system-74865604f2b2a4a531bebb09b7fddd9e.svg";